export const actions = {
  setInformationIndexAsync: (context, payload) => {
      context.commit('setInformationIndex', payload)
  },
  setAreaIdAsync: (context, payload) => {
      context.commit('setAreaId', payload)
  },
  setNavNameAsync: (context, payload) => {
      context.commit('setNavName', payload)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js